import {Fragment, useState} from 'react';

export const DisplayDesktopTabs = ({tabNames, sections}) => {
  const [activeTab, setActiveTab] = useState(tabNames?.[0]);
  // console.log('[DisplayDesktopTabs] sections:', sections);

  const handleTabClick = (tabName) => (event) => {
    event.preventDefault(); // Prevent default anchor behavior
    setActiveTab(tabName);
    // Optionally, update the URL hash if needed
    // window.history.pushState(null, null, `#${tabName}`);
  };

  const activeTabIndex = tabNames?.findIndex((name) => name === activeTab);

  return (
    <>
      <div className='border-b border-gray-200 dark:border-gray-700'>
        <ul className='flex -mb-px overflow-x-auto'>
          {tabNames?.map((tabName) => {
            // console.log("[DisplayDesktopTabs] tabName: ", tabName)
            return (
              <li className='mr-2' key={tabName}>
                <a
                  href={`#${tabName}`}
                  onClick={handleTabClick(tabName)}
                  className={`inline-block whitespace-nowrap py-4 px-4 text-sm font-medium text-center ${
                    activeTab === tabName
                      ? 'text-tab-active text-gray-900 rounded-t-lg border-gray-900 active dark:text-blue-500 dark:border-blue-500 border-b-2'
                      : 'text-tab-off text-gray-500 rounded-t-lg border-transparent hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                  }`}>
                  {tabName}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
      <div className='tab-content' id='tabs-home-tab' style={{marginBottom: '10pt'}}>
        {sections[activeTabIndex] && (
          <div
            className={`prose tab-pane pt-1.5 fade ${
              activeTab === tabNames[activeTabIndex] ? 'show active' : 'hidden'
            }`}
            id={tabNames[activeTabIndex]}
            role='tabpanel'>
            {Array.isArray(sections[activeTabIndex])
              ? sections[activeTabIndex].map((productRow, index) => {
                  return <Fragment key={index}>{productRow}</Fragment>;
                })
              : sections[activeTabIndex]}
          </div>
        )}
      </div>
    </>
  );
};
